import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import coverImage from "../../../../media/images/headCover.svg";
import BigCar from "../../../../media/images/icons/bigCar";
import ArrowLeft from "../../../../media/images/icons/arrow-left";
import BoxIcon from "../../../../media/images/icons/box";
import CompanyIcon from "../../../../media/images/icons/company-icon";
import { Link } from "react-router-dom";
import LinkCard from "./LinkCard";

export default function SignupGuide() {
  const theme = useTheme();

  const links = [
    {
      title: "راهنما ثبت‌نام رانندگان",
      icon: <BigCar />,
    },
    {
      title: "راهنما ثبت‌نام صاحبین بار",
      icon: <BoxIcon />,
    },
    {
      title: "راهنما ثبت‌نام شرکت‌های حمل و نقل",
      icon: <CompanyIcon />,
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          borderRadius: "20px",
          alignItems: "center",
          justifyContent: "center",
          paddingX: "16px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "32px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          راهنمای بازارگاه{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "32px",
            color: "background.default",
          }}
        >
          راهنمای ثبت نام{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          px: 3,
          mt: 2,
        }}
      >
        <Typography>
          شما می توانید به عنوان هرکدام یا همه اشخاص زیر در بازارگاه بار
          کارن‌ترابرنت ثبت‌نام کنید.
        </Typography>
        <Typography
          sx={{
            maxWidth: "65%",
            margin: "auto",
            textAlign: "center",
            fontWeight: 600,
          }}
        >
          برای مشاهده راهنمای ثبت‌نام هرکدام، کافی‌است بر روی آن ضربه بزنید:
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {links.map((item) => (
          <LinkCard icon={item.icon} title={item.title} />
        ))}
      </Box>
    </>
  );
}
